export default "__VITE_ASSET__DppuohEn__"